<!-- 产品中心 -->
<template>
  <div>
    <div id="cont">
      <div class="cont">
        <div class="cont_l">
          <div class="cont_l_01">
            <div class="cont_l_02">
              <img :src="images.cps_03">
            </div>
            <div class="cont_l_03">
              <ul class="lit01">
                <li class="lit01_c">
                  <p class="littitle">{{text.product1}}</p>
                  <ul class="lit02">
                    <li class="lit02_a">
                      <router-link to="/productzh/ysjszh">{{text.product2}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/productzh/lbzh">{{text.product3}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/productzh/crqdzh">{{text.product4}}</router-link>
                    </li>
                  </ul>

                  <p class="littitle">{{text.product5}}</p>

                  <ul class="lit02">
                    <li class="lit02_a">
                      <router-link to="/productzh/kcpzh">{{text.product6}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/productzh/hhxtzh">{{text.product7}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/productzh/xtghjzh">{{text.product8}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/productzh/jsgzh">{{text.product9}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/productzh/ntzh">{{text.product10}}</router-link>
                    </li>
                  </ul>

                 <p class="littitle">{{text.product11}}</p>

                  <ul class="lit02">
                    <li class="lit02_a">
                      <router-link to="/productzh/tszpzh">{{text.product12}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/productzh/lytkzh">{{text.product13}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/productzh/yjmzh">{{text.product14}}</router-link>
                    </li>
                  </ul>

                  <p class="littitle">{{text.product15}}</p>
                  <ul class="lit02">
                    <li class="lit02_a">
                      <router-link to="/productzh/yybjzh">{{text.product16}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/productzh/cytqwzh">{{text.product17}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/productzh/chszh">{{text.product18}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/productzh/ggtqwzh">{{text.product19}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/productzh/sfjtqwzh">{{text.product20}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/productzh/ptztqwzh">{{text.product21}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/productzh/lsrgszh">{{text.product22}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/productzh/lsjyzh">{{text.product23}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/productzh/ysyzh">{{text.product24}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/productzh/rjzh">{{text.product25}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/productzh/laszh">{{text.product26}}</router-link>
                    </li>
                  </ul>
                 <p class="littitle">{{text.product27}}</p>
                  <ul class="lit02">
                    <li class="lit02_a">
                      <router-link to="/productzh/hgylzh">{{text.product28}}</router-link>
                    </li>
                  </ul>
                  <p class="littitle">{{text.product29}}</p>
                  <ul class="lit02">
                    <li class="lit02_a">
                      <router-link to="/productzh/gtllzh">{{text.product30}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/productzh/jsmdzh">{{text.product31}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/productzh/bxxzh">{{text.product32}}</router-link>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
            <div class="cont_l_04"></div>
          </div>
        </div>
        <div class="cont_r">
          <div class="cont_r_t">
            <div class="cont_r_t01">
              <span>{{text.profile3}}</span>
              <span>：</span>
              <span>{{text.profile4}}</span>
              <span>-</span>
              <span>{{text.product33}}</span>
            </div>
          </div>
          <div class="cont_r_b">
            <div id="rightdiv">
              <router-view></router-view>
            </div>
            <div class="cont_r_b10">
              <router-link to="/bbszh" target="_blank">
                <img :src="images.scy_03">
              </router-link>
            </div>
            <div class="clear"></div>
          </div>
        </div>
        <div class="clear"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        scy_03: require("../../../assets/img/zh/scy_03.jpg"),
        cps_03: require("../../../assets/img/zh/cps_03.jpg")
      },
      text: {
        profile3: "您当前所在位置",
        profile4: "首页",
        product1: "有色金属",
        product2: "黄铜锭，青铜锭，紫铜锭",
        product3: "铝板，铝卷，铝箔，罐身料",
        product4: "重熔铅锭，重熔锌锭",
        product5: "矿产品、稀土及铁合金",
        product6: "铬矿，锰矿",
        product7: "混合稀土金属",
        product8: "稀土硅合金",
        product9: "金属硅",
        product10: "镍铁，硅铁，锰铁，硅锰，钼铁，铬铁，钛铁，钒铁",
        product11: "炭素制品及冶金煤",
        product12: "电极",
        product13: "铝用炭块，预焙阳极，电极糊，石墨块，煅后焦，增碳剂",
        product14: "冶金煤",
        product15: "医药保健原料",
        product16: "石杉碱甲",
        product17: "茶叶提取物",
        product18: "茶黄素，速溶茶",
        product19: "葛根提取物",
        product20: "水飞蓟提取物",
        product21: "葡萄籽提取物",
        product22: "硫酸软骨素",
        product23: "氨基葡萄糖硫酸钾盐",
        product24: "氨基葡萄糖盐酸盐",
        product25: "L-肉碱",
        product26: "L-酪氨酸,L-精氨酸,à-硫辛酸",
        product27: "化工原料",
        product28: "钛白粉，无水碳酸钠，氟化铝，人造冰晶石",
        product29: "钢铁及炉料",
        product30: "金属锰锭，金属锰片，金属锰枕",
        product31: "金属镁锭，金属镁粒，金属钙粒",
        product32: "包芯线",
        product33: "产品中心"
      }
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/zh/product/product.vue